"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./setup.init");
require("./setup.params");
require("./setup.css");
require("./setup.device");
require("./setup.items");
require("./setup.languages");
require("./setup.scripts");
require("./setup.scripts.client");
require("./setup.configs");
require("./setup.scripts.packages");
